import { Spinner } from 'alurkerja-ui';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';

interface Section extends PropsWithChildren {
  title: string;
  description?: string | (() => ReactNode);
  action?: () => ReactNode;
  width?: '100%' | '50%';
  loading?: boolean;
}

export const Section: FC<Section> = ({ title, description, children, action, width = '100%', loading = false }) => {
  const mappingWidth = {
    '100%': 'w-full',
    '50%': 'w-full lg:w-1/2',
  };

  return (
    <section className={twJoin('bg-white rounded min-h-[calc(100vh-100px)]', mappingWidth[width])}>
      <div
        data-testid="section-header"
        className="flex items-center flex-wrap justify-between px-2 py-2 sm:px-6 sm:py-4 border-b"
      >
        <div>
          <h3 className="font-semibold capitalize">{title}</h3>
          {typeof description === 'string' ? <p>{description}</p> : description?.()}
        </div>

        {action?.()}
      </div>

      <div data-testid="section-body">
        {loading ? (
          <div
            data-testid="loading-container"
            className="flex items-center justify-center gap-2.5 p-6 flex-col"
          >
            <Spinner className="text-main-blue-alurkerja" />
            Sedang mengambil data
          </div>
        ) : (
          children
        )}
      </div>
    </section>
  );
};
